module.exports = __webpack_public_path__ + "img/open-tendering@3x.1c715316.png";